import "@features/i18n";
import { useTheme } from "@features/use-theme";
import { Theme } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";
import ReactDOM from "react-dom/client";
import TagManager from "react-gtm-module";
import { QueryClient, QueryClientProvider } from "react-query";
import { Toaster } from "sonner";
import "./animate.css";
import { Env } from "./env";
import "./index.css";
import { Router } from "./router";

if (!document.location.host.includes("local")) {
  Sentry.init({
    dsn: "https://005e17decd4aebb0e77e810dcd5b1917@o4508291579969536.ingest.de.sentry.io/4508886196944976",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
    },
  },
});

(window as any).dataLayer = (window as any).dataLayer || [];
export function gtag(event: any) {
  (window as any).dataLayer.push(event);
}

const Root = () => {
  useTheme();
  TagManager.initialize({ gtmId: "GTM-5TRT2RVL" });
  return (
    <PostHogProvider
      apiKey={Env.posthogApiKey}
      options={{
        api_host: Env.posthogApiHost,
        defaults: "2025-05-24",
        capture_exceptions: true,
        debug: false,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <Theme
          accentColor="indigo"
          grayColor="slate"
          radius="full"
          scaling="100%"
          appearance={"inherit"}
        >
          <Router />
          <Toaster richColors position={"top-center"} />
        </Theme>
      </QueryClientProvider>
    </PostHogProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<Root />);
